import { ScoreTierEntity } from 'pages/LenderWaterfall/ScorecardBuilder/types';
import { initialFinanceProgramTierTableData } from '../constants';
import { FinanceProgramTierForm } from '../schema';

export function getInitialFinanceProgramTiersTableData(scoreTiers: ScoreTierEntity[]): FinanceProgramTierForm[] {
  return scoreTiers.map(st => ({ name: st.name, color: st.color, ...initialFinanceProgramTierTableData }));
}
